import React from "react";
import Header from "../component/Home/Header";
import AboutMiddleSection from "../component/About/AboutMiddleSection";
import AboutImages from "../component/About/AboutImages";
import AboutLocation from "../component/About/AboutLocation";
import AboutTab from "../component/About/AboutTab";
import AboutStory from "../component/About/AboutStory";
import AboutMission from "../component/About/AboutMission";
import AboutVision from "../component/About/AboutVision";
import AboutFooter from "../component/About/AboutFooter";
import Footer from "../component/Home/Footer";
import { useEffect } from "react";
import { updateMetaTagContent, updateTitle } from "../action/customFn";
import { Helmet } from "react-helmet-async";
import AboutStats from "../component/About/AboutStats";
import AboutLocal from "../component/About/AboutLocal";
import WhyChooseUs from "../component/About/WhyChooseUs";
import AboutFeature from "../component/About/AboutFeature";
import AboutStanding from "../component/About/AboutStanding";
import AboutCommitment from "../component/About/AboutCommitment";
import AboutHero from "../component/About/AboutHero";
import "../component/About/aboutresponsive.css";

const AboutNew = () => {
  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="One Platform for students to become global certified professional. Apply for top courses, MGTIP programs, virtual internship & International remote Jobs."
        />
        <meta
          name="keywords"
          content="Global Training Courses, 
          Mentorship Program, 
          top courses,
           Virtual mentorship & training program,
          Global training & mentorship Program,
           virtual mentorship,
          International Jobs, 
          abroad virtual internship,
           Certification Courses,"
        />
        <title>
          MetBrains - Find Global Training Courses & Virtual Mentorship
        </title>

        <link rel="canonical" href="https://metbrains.com/about" />
      </Helmet>
      <Header />
      <AboutHero />
      <AboutStats />
      <AboutLocal />
      <WhyChooseUs />
      <AboutFeature />
      <AboutStanding />
      <AboutCommitment />
      <Footer />
    </>
  );
};

export default AboutNew;
